import { Fragment, React, useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { FaCity } from "react-icons/fa6";
import { IoIosPerson } from "react-icons/io";
import { IoTicketSharp, IoTodaySharp } from "react-icons/io5";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import useUserInformation from "../../../hooks/useUserInformation";
import { getAuthMethod } from "../../helper";
import HamburgerMenu from "./components/HamburgerMenu";
import "./mainMenu.css";
import { BsCreditCardFill, BsFillCreditCardFill } from "react-icons/bs";
import { MdSupervisorAccount } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { CiCircleList } from "react-icons/ci";

function MainMenu({ data, children }) {
  const {
    user,
    agent,
    isAgent,
    isDistrictManger,
    isSupervisor,
    isDigikalaCoworker,
  } = useUserInformation();

  const [collapsedSidebar, setCollapsedSidebar] = useState(false);

  const [countData, setCountData] = useState({
    data: 0,
    driver: 0,
    overhung: 0,
    transferring: 0,
  });

  const getCount = async () => {
    const count = await getAuthMethod("/totalpost/v1/agent/count");

    if (count && count.status === 200) {
      setCountData(count.data);
    }
  };

  const logOutt = () => {
    Swal.fire({
      icon: "error",
      title: "خروج",
      html: "<p style='font-size: 20px'>آیا مطمئن هستید ؟</p>",
      confirmButtonText: "بله",
      confirmButtonColor: "red",
      showCancelButton: true,
      cancelButtonText: "خیر",
      iconColor: "red",
    }).then(e => {
      if (e.isConfirmed) window.location.href = "/logout";
    });
  };

  useEffect(() => {
    if (isAgent) getCount();
  }, []);

  const [sidebarHamburger, setSidebarHamburger] = useState(false);

  const getSidebarInfo = () => {
    if (isDistrictManger) {
      return { class: "district-manger-bg", name: "مدیر منطقه سامانه آواکس" };
    }

    if (isSupervisor) {
      const name = "سرپرست استان " + user.supervisor.province?.faName;
      return { class: "supervisor-bg", name };
    }

    if (isDigikalaCoworker) {
      const name = "همکار دیجی‌کالا محترم";
      return { class: "agent-bg", name };
    }

    const name = "نماینده شهر " + (agent ? agent.city.faName : "...");
    return { class: "agent-bg", name };
  };

  return (
    <div className="w-100" style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar
        rtl={true}
        width="270px"
        className={
          "sidebar " +
          getSidebarInfo().class +
          (sidebarHamburger ? " sidebar-active" : "")
        }
        rootStyles={{
          color: "white",
          border: "none",
        }}
        collapsed={collapsedSidebar}
      >
        <Menu className="sidebar-hover">
          <MenuItem className="mb-3 mt-3">
            <Icon.List
              width="30"
              height="30"
              color={"#ff6600"}
              onClick={() => setCollapsedSidebar(cur => !cur)}
            >
              Collapse
            </Icon.List>
          </MenuItem>

          {isDigikalaCoworker && (
            <SubMenu icon={<FaStore />} label="دیجی‌کالا">
              <MenuItem
                icon={<IoTodaySharp />}
                component={<Link to="/digikala/coworker/today" />}
              >
                مرسولات امروز
              </MenuItem>

              <MenuItem
                icon={<CiCircleList size={24} />}
                component={<Link to="/digikala/coworker/list" />}
              >
                لیست مرسولات
              </MenuItem>
              <MenuItem
                icon={<BsFillCreditCardFill />}
                component={<Link to="/digikala/coworker/credit" />}
              >
                اعتبار
              </MenuItem>
            </SubMenu>
          )}

          {isDistrictManger && (
            <SubMenu icon={<IoIosPerson />} label="مدیر منطقه">
              <MenuItem
                icon={<IoTodaySharp />}
                component={<Link to="/district-manager/todey-shipments" />}
              >
                مرسولات امروز
              </MenuItem>
              <MenuItem
                component={<Link to="/district-manager/shipments" />}
                icon={<Icon.ClipboardDataFill />}
              >
                لیست مرسولات
              </MenuItem>
              <MenuItem
                component={<Link to="/district-manager/supervisors" />}
                icon={<MdSupervisorAccount />}
              >
                لیست سرپرست ها
              </MenuItem>
            </SubMenu>
          )}

          {isSupervisor && (
            <SubMenu icon={<IoIosPerson />} label="سرپرستی">
              <MenuItem
                icon={<IoTodaySharp />}
                component={<Link to="/supervisor/todey-shipments" />}
              >
                مرسولات امروز
              </MenuItem>
              <MenuItem
                component={<Link to="/supervisor/shipments" />}
                icon={<Icon.ClipboardDataFill />}
              >
                لیست مرسولات
              </MenuItem>
              <MenuItem
                component={<Link to="/supervisor/agents" />}
                icon={<MdSupervisorAccount />}
              >
                لیست نماینده ها
              </MenuItem>
              <MenuItem
                component={<Link to="/supervisor/credit" />}
                icon={<BsCreditCardFill />}
              >
                اعتبار
              </MenuItem>
              <MenuItem
                component={<Link to="/supervisor/tickets" />}
                icon={<IoTicketSharp />}
              >
                تیکت ها
              </MenuItem>
            </SubMenu>
          )}

          {isAgent && (
            <Fragment>
              <SubMenu
                icon={<Icon.Boxes />}
                suffix={
                  <span className="badge rounded-pill bg-danger">
                    {countData.data +
                      countData.driver +
                      countData.overhung +
                      countData.transferring}
                  </span>
                }
                label="مرسولات"
              >
                <MenuItem
                  component={<Link to="/collected" />}
                  icon={<Icon.BoxFill />}
                  suffix={
                    <div style={{ flexDirection: "column", display: "flex" }}>
                      <span className="badge rounded-pill bg-danger">
                        {countData.data}
                      </span>
                      <span className="badge rounded-pill bg-warning">
                        {countData.part}
                      </span>
                    </div>
                  }
                >
                  جمع آوری نشده
                </MenuItem>
                <MenuItem
                  component={<Link to="/driverWait" />}
                  icon={<Icon.TruckFlatbed />}
                  suffix={
                    <span className="badge rounded-pill bg-danger">
                      {countData.driver}
                    </span>
                  }
                >
                  ارجاع به راننده
                </MenuItem>
                <MenuItem
                  component={<Link to="/overhung" />}
                  icon={<Icon.Shop />}
                  suffix={
                    <span className="badge rounded-pill bg-danger">
                      {countData.overhung}
                    </span>
                  }
                >
                  معلق در فروشگاه
                </MenuItem>
                <MenuItem
                  component={<Link to="/returned" />}
                  icon={<Icon.ReplyFill />}
                >
                  برگشتی
                </MenuItem>
                <MenuItem
                  component={<Link to="/transferring" />}
                  icon={<Icon.TruckFrontFill />}
                  suffix={
                    <div>
                      <span className="badge rounded-pill bg-danger">
                        {countData.transferring}
                      </span>
                    </div>
                  }
                >
                  در حال جابه جایی
                </MenuItem>
                <MenuItem
                  component={<Link to="/deliveredcostomer" />}
                  icon={<Icon.SendCheckFill />}
                >
                  تحویل داده شد
                </MenuItem>
              </SubMenu>

              <SubMenu icon={<Icon.GraphUpArrow />} label="گزارشات">
                <MenuItem
                  component={<Link to="/myShipmentPage" />}
                  icon={<Icon.ClipboardDataFill />}
                >
                  گزارش گیری مرسولات
                </MenuItem>
                <MenuItem
                  component={<Link to="/afterRentReport" />}
                  icon={<Icon.Clipboard />}
                >
                  مرسولات پس کرایه
                </MenuItem>
              </SubMenu>

              <MenuItem
                component={<Link to="/driver" />}
                icon={<Icon.CarFrontFill />}
              >
                رانندگان جمع آور
              </MenuItem>
            </Fragment>
          )}

          <MenuItem
            component={<Link to="/wallet" />}
            icon={<Icon.WalletFill />}
          >
            مالی
          </MenuItem>

          <MenuItem component={<Link to="/city-check" />} icon={<FaCity />}>
            مدیریت شهر ها
          </MenuItem>

          <MenuItem href="https://avaex.ir" icon={<Icon.HouseFill />}>
            رفتن به سایت آواکس
          </MenuItem>

          <MenuItem icon={<Icon.BoxArrowRight />} onClick={() => logOutt()}>
            خروج
          </MenuItem>
        </Menu>
      </Sidebar>

      <div className="containerArea">
        <Navbar
          expand="lg"
          sticky={"top"}
          className={"py-0 " + getSidebarInfo().class}
        >
          <Container className="py-2 ">
            <Navbar.Brand
              style={{ color: "white", fontWeight: "500", fontSize: "0.9rem" }}
            >
              <span>{user.name + " " + (user.family ?? "")}</span>
              <span> {getSidebarInfo().name}</span>
              <span> خوش آمدید</span>
            </Navbar.Brand>
            <div className="d-flex me-auto">
              <button className="btn-exit ms-3" onClick={() => logOutt()}>
                خروج
              </button>
              <HamburgerMenu onClick={() => setSidebarHamburger(cur => !cur)} />
            </div>
          </Container>
        </Navbar>
        <div className="w-100 my-4">
          {data}
          {children}
        </div>
      </div>
    </div>
  );
}

export default MainMenu;
